import React, { useState } from "react";
import InquiryForm from "./InquiryForm"; // Import your InquiryForm component

const ReferAndEarn = () => {
 // State to control modal visibility
  const [showQuotation, setShowQuotation] = useState(false); // State for showing quotation modal

  // Function to open the modal
 
  // Function to close the quotation modal
  const closeQuotation = () => {
    setShowQuotation(false);
  };

  return (
    <div className="relative">
    <div className="bg-gray-100 rounded-xl shadow-md p-6 sm:p-12 text-center">
    <h3 className="text-2xl font-semibold mb-4">Refer & Earn</h3>
    <p className="text-m text-gray-500">
      <span className="text-[#e9a200] font-bold text-xl">₹10,000 </span>
      everytime your friends and family get their interiors done by <br/>Grow Home Studio
    </p>
    <button
      onClick={() => setShowQuotation(true)} // Open quotation modal when clicked
      className="mt-4 bg-[#e9a200] text-white font-bold py-2 px-4 rounded-xl w-full sm:w-72 hover:bg-[#d68d00] transition-colors"
    >
      Know More
    </button>
    <p className="text-xs text-gray-500 mt-4">*Terms & Conditions Apply</p>
  </div>
  

      {/* Quotation Modal */}
      {showQuotation && (
        <div className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50 backdrop-blur-sm">
          <div className="bg-white p-6 rounded-lg shadow-xl w-[90%] max-w-md sm:w-96">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-l font-italic pl-4">Refer your friends and family</h2>
              <button
                className="text-gray-500 hover:text-gray-800"
                onClick={closeQuotation} // Close quotation modal when "X" is clicked
              >
                ✖
              </button>
            </div>
            <InquiryForm /> {/* Your existing inquiry form */}
          </div>
        </div>
      )}
    </div>
  );
};

export default ReferAndEarn;
